import { IBetState } from '@GameStore/GameStoreSchema';

export const BET_STATE_DEFAULTS: IBetState = {
    value: {
        raw: 0,
        normalized: 0,
        formatted: ''
    },
    index: 0,
    maxIndex: 0,
    maxValue: {
        raw: 0,
        normalized: 0,
        formatted: ''
    },
    betSteps: [],
    availableBetSteps: [],
    available: false,
    currencySymbol: ''
};
